import React from "react";
import Shadow from "../Shadow";
import RadioBox from "../forms/RadioBox";

const Plug = props => {
    return <div  id="bl_4_grid_item_2" className={"bl_4_grid_item"}>
        {props.shadow && <Shadow />}
        <div className="calc_title_box">
            <div className="calc_title">Вид</div>
            <RadioBox name={"view"} value={"transparent"} func={() => props.reload()} txt={"Прозрачное"}/>
            <RadioBox name={"view"} value={"light"} func={() => props.reload()} txt={"Осветлённое"}/>
            <RadioBox name={"view"} value={"matt"} func={() => props.reload()} txt={"Матовое"}/>
            <RadioBox name={"view"} value={"bronze"} func={() => props.reload()} txt={"Бронза"}/>
            <RadioBox name={"view"} value={"gray"} func={() => props.reload()} txt={"Графит"}/>
        </div>
    </div>
}


export default Plug;
